import React from 'react'
import { data } from '../../../data/data';
import { Link } from 'react-router-dom';
import { useState } from 'react';


function Ossature() {
    const tableauBody = document.getElementsByClassName('tableau-body')

    const [isTableVisible, setTableVisible] = useState(true);

    const toggleTable = () => {
        if (isTableVisible) {
            tableauBody[0].style.height = '211px'
            tableauBody[0].style.opacity = '1'
            setTimeout(() => {
                tableauBody[0].style.height = 'fit-content'
                const tableauHeight = tableauBody[0].offsetHeight
                tableauBody[0].style.height = tableauHeight + "px"
            }, 300)
        }
        else {
            tableauBody[0].style.opacity = '0'
            tableauBody[0].style.height = '0px'
        }
        setTableVisible(!isTableVisible);
    }
    // Filtrer les produits de la catégorie 'amenagement'
    const amenagementProducts = data
        .filter(product => product.categorie.includes('ossature'))
        .sort((a, b) => a.name.localeCompare(b.name));
    return (
        <div className='ossature'>
            <h1><Link to="/bois-de-charpente">&#x2B05;</Link>Bois d'ossature</h1>
            <fleche className='fleche-div'>
                <Link to="/bois-de-charpente" className='fleche'>⬅</Link>
            </fleche>
            <table className='tableau' onClick={toggleTable}>
                <thead>
                    <tr>
                        <td colspan="5"> Tableau de comparaison </td>
                    </tr>
                </thead>
                <tbody className='tableau-body'>
                    <tr>
                        <td>Produit</td>
                        <td>Section (En cm)</td>
                        <td>Longeur (En m)</td>
                        <td>Tarif en Euros TTC au ml en Douglas</td>
                    </tr>

                    <tr>
                        <td rowSpan={4}>Bois d'ossature</td>
                        <td>4.5x9.5</td>
                        <td>3 / 4 / 5</td>
                        <td>3.38</td>
                    </tr>

                    <tr>
                        <td>4.5x12</td>
                        <td>4</td>
                        <td>4.27</td>
                    </tr>

                    <tr>
                        <td>4.5x14.5</td>
                        <td>3 / 4 / 5</td>
                        <td>5.17</td>
                    </tr>

                    <tr>
                        <td>4.5x22</td>
                        <td>4 et 5</td>
                        <td>7.84</td>
                    </tr>
                </tbody>
            </table>
            <div className='cartes'>
                {amenagementProducts.map((product, index) => (
                    <div key={index} className='carte-produit'>
                        <img src={product.imageUrl} alt={product.name} />
                        <div>
                            <h2>{product.name}</h2>
                            <p>Essence : <span>{product.essence}</span></p>
                            <p>Epaisseur : <span>{product.epaisseur}cm</span></p>
                            <p>Largeur : <span>{product.largeur}cm</span></p>
                            <p>Longueur : <span>{product.longeur}m</span></p>
                            <p>Qualité/Finition : <span>{product.qualite}</span></p>
                            <p>Prix TTC au ml : <span>{product.prix}€</span></p>
                            {product.prixSec && product.prixSec !== "" && (
                                <p>Prix TTC au ml : <span>{product.priSec}€</span></p>
                            )
                            }
                            <a href={product.fiche} target='_blank' rel="noreferrer" className='devis'>Fiche Technique</a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Ossature